import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Cabanas from "@/pages/Cabanas";
import CabanaDetalhes from "@/pages/CabanaDetalhes";
import Reservas from "@/pages/Reservas";
import FAQ from "@/pages/FAQ";
import Contato from "@/pages/Contato";

function ScrollToTop() {
    const { pathname } = useLocation();
    React.useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [pathname]);
    return null;
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/cabanas" element={<Cabanas />} />
                        <Route path="/cabanas/:slug" element={<CabanaDetalhes />} />
                        <Route path="/reservas" element={<Reservas />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="/contato" element={<Contato />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
